import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "d-flex",
  style: {"min-height":"45vw"}
}
const _hoisted_2 = {
  class: "content p-4 w-100",
  style: {"min-width":"75%"}
}
const _hoisted_3 = { class: "d-flex justify-content-between mb-1" }
const _hoisted_4 = { class: "card-title mt-0" }
const _hoisted_5 = { class: "w-100" }
const _hoisted_6 = { class: "w-100 mt-6" }
const _hoisted_7 = { class: "d-flex justify-end mt-6" }

import DuplicationConfirmModal from "@/components/RoleAssignment/DuplicationConfirmModal.vue"
import getRoleAssignAccountsResponse from "@/types/responses/getRoleAssignAccountsResponse"
import getRoleAssignAccountResponseType from "@/types/responses/getRoleAssignedAccount"
import PersonInCharge from "@/components/RoleAssignment/PersonInCharge.vue"
import roleAssignAccountType from "@/types/responses/roleAssignAccount"
import createOrUpdateRole from "@/types/requests/createOrUpdateRole"
import UserSearch from "@/components/RoleAssignment/UserSearch.vue"
import getDepartmentResponse from "@/types/responses/getDepartment"
import RoleSelect from "@/components/RoleAssignment/RoleSelect.vue"
import organizationType from "@/types/requests/organizationType"
import { scrollToErrorComponent } from "@/services/validators"
import { scrollTop, scrollToTop } from "@/services/functions"
import getOfficesResponse from "@/types/responses/getOffices"
import { DEPARTMENT_OFFICE_TYPE } from "@/services/consts"
import { ref, Ref, onMounted, watch } from "vue"
import Api from "@/services/api/ApiServiceFabrick"
import getRoles from "@/types/responses/getRoles"
import getRole from "@/types/responses/getRole"
import accountType from "@/types/account"
import i18n from "@/lang/i18n"

type searchItemsType = {
  organization: {
    id: number,
    name: string,
    type: string
  } | null,
  userName: string
}

type requestIdsType = {
  assigns: (roleAssignAccountType | accountType)[],
  unassigns: (roleAssignAccountType | accountType)[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'RoleAssaignment',
  props: {
    showFlash: { type: Function },
    switchContentLoading: { type: Function }
  },
  setup(__props: any) {

document.title = i18n.global.t('pages.roleAssignment.title')

const props = __props

const roles: Ref<getRole[]> = ref([])
const alreadySelectedRoleId: Ref<number | null> = ref(null)
const searchItems: Ref<searchItemsType> = ref({
  organization: null,
  userName: ''
})
const assigns: Ref<(roleAssignAccountType | accountType)[]> = ref([])
const requestIds: Ref<requestIdsType> = ref({
  assigns: [],
  unassigns: []
})
const displayAssigns: Ref<roleAssignAccountType[]> = ref([])
const selectableAccounts: Ref<roleAssignAccountType[]> = ref([])
const departments: Ref<getDepartmentResponse[]> = ref([])
const organizations: Ref<organizationType[]> = ref([])
const isCreateOrUpdating: Ref<boolean> = ref(false)
const inforModalStatus: Ref<boolean> = ref(false)
const isConfirmed: Ref<boolean> = ref(false)
const windowInnerWidth: Ref<number> = ref(window.innerWidth)
const loading: Ref<boolean> = ref(false)
const filterValidationErrors: Ref<{
  organization: string[],
  roleType: string[],
  userSearchOrganization: string[],
}> = ref({
  organization: [],
  roleType: [],
  userSearchOrganization: []
})
const selectedOrganizationAndRole: Ref<{
  organization: organizationType | null,
  role: getRole | null
}> = ref({
  organization: null,
  role: null
})
const isSuccessed: Ref<boolean> = ref(false)
const alreadyAssignedAccountIds: Ref<number[]> = ref([])

onMounted(() => {
  scrollToTop()
  requestApis()
  getOrganizationOffices()
})

async function requestApis() {
  props.switchContentLoading(true)
  await getAllRoles()
  props.switchContentLoading(false)
  selectedOrganizationAndRole.value.role = alreadySelectedRole()
}

async function getOrganizationOffices() {
  await getOffices()
  getDepartments()
}

async function getAllRoles() {
  await Api().getRoles().then((data: getRoles) => {
    roles.value = data.data
  }).catch((error) => {
    errorHandle(error.response)
  })
}

async function getAccounts() {
  await Promise.all([
    getAllAccounts(),
    getRoleAssignedAccounts()
  ])
}

async function getAllAccounts() {
  await Api().getRoleAssignAccounts(makeGetAccountsRequestParams()).then((data: getRoleAssignAccountsResponse) => {
    selectableAccounts.value = data.data
  }).catch((error) => {
    errorHandle(error.response)
  })
}

async function getRoleAssignedAccounts() {
  if (!selectedOrganizationAndRole.value.role) {
    return
  }
  await Api().getRoleAssignedAccounts(selectedOrganizationAndRole.value.role.id, makeGetAssignedAccountsRequestParams()).then((data: getRoleAssignAccountResponseType[]) => {
    alreadyAssignedAccountIds.value = data.map((account) => account.id)
  }).catch((error) => {
    errorHandle(error.response)
  })
}

async function getOffices() {
  Api().getOffices().then((data: getOfficesResponse[]) => {
    data.forEach((office: getOfficesResponse) => {
      organizations.value.push({
        id: office.id,
        name: office.company_name ?? office.operation_office_name,
        type: office.type
      })
    })
  })
}

async function getDepartments() {
  await Api().autoCompleteDepartments(undefined)
    .then((data: getDepartmentResponse[]) => {
      departments.value = data
      data.forEach((department: getDepartmentResponse) => {
        organizations.value.push({
          id: department.id,
          name: department.name,
          type: DEPARTMENT_OFFICE_TYPE
        })
      })
    })
}

function makeGetAccountsRequestParams() {
  if (searchItems.value.organization?.type == DEPARTMENT_OFFICE_TYPE) {
    return {
      department_id: searchItems.value.organization?.id,
      account_name: searchItems.value.userName
    }
  }
  return {
    type_class: searchItems.value.organization?.type,
    officeable_id: searchItems.value.organization?.id,
    account_name: searchItems.value.userName
  }
}

function makeGetAssignedAccountsRequestParams() {
  if (searchItems.value.organization?.type == DEPARTMENT_OFFICE_TYPE) {
    return {
      department_id: searchItems.value.organization?.id,
      account_name: searchItems.value.userName
    }
  }
  return {
    officeable_type: searchItems.value.organization?.type,
    officeable_id: searchItems.value.organization?.id,
    account_name: searchItems.value.userName
  }
}

function alreadySelectedRole() {
  if (!alreadySelectedRoleId.value) return null
  return roles.value.find((role) => role.id === alreadySelectedRoleId.value) ?? null
}

async function filter() {
  if (!validationSearchCanditions()) {
    return
  }
  refreshAccounts()
  loading.value = true
  await getAccounts()
  if (alreadyAssignedAccountIds.value.length) {
    alreadyAssignedAccountIds.value.forEach((id: number) => {
      let index = selectableAccounts.value.findIndex((account) => account.id === id)
      if (index !== -1 && selectableAccounts.value[index]) {
        assigns.value.push(selectableAccounts.value[index])
      }
    })
  }
  loading.value = false
  displayAssigns.value = JSON.parse(JSON.stringify(assigns.value))
}

function refreshValidationMessages() {
  filterValidationErrors.value.organization = []
  filterValidationErrors.value.roleType = []
  filterValidationErrors.value.userSearchOrganization = []
}

function validationSearchCanditions() {
  refreshValidationMessages()
  let isValid = true

  if (!selectedOrganizationAndRole.value.organization) {
    filterValidationErrors.value.organization.push(i18n.global.t('pages.roleAssignment.validations.organization.required'))
    isValid = false
  }

  if (!selectedOrganizationAndRole.value.role) {
    filterValidationErrors.value.roleType.push(i18n.global.t('pages.roleAssignment.validations.roleType.required'))
    isValid = false
  }
  if (!searchItems.value.organization) {
    filterValidationErrors.value.userSearchOrganization.push(i18n.global.t('pages.roleAssignment.validations.userSearch.orzanization.required'))
    isValid = false
  }
  if (!isValid) {
    scrollToErrorComponent()
  }
  return isValid
}

function createOrUpdate() {
  refreshValidationMessages()
  if (!isConfirmed.value && isDuplicationOffice()) return inforModalStatus.value = true
  isCreateOrUpdating.value = true
  const requestParams: createOrUpdateRole = {
    assigns: requestIds.value.assigns.map((assign: (roleAssignAccountType | accountType)) => {
      return assign.id
    }),
    unassigns: requestIds.value.unassigns.map((unassign: (roleAssignAccountType | accountType)) => {
      return unassign.id
    })
  }
  if (!selectedOrganizationAndRole.value.role) return
  Api().createOrUpdateRole(selectedOrganizationAndRole.value.role.id, requestParams).then(() => {
    success()
  }).catch((error) => {
    errorHandle(error.response)
  })
}

function success() {
  isSuccessed.value = true
  isConfirmed.value = false
  isCreateOrUpdating.value = false
  props.showFlash(i18n.global.t('pages.common.messages.success'), "success", true)
  scrollTop('flash-message-component')
  if (selectedOrganizationAndRole.value.role) {
    alreadySelectedRoleId.value = selectedOrganizationAndRole.value.role.id
  }
  requestApis()
  getRoleAssignedAccounts()
}

function errorHandle(error: any) {
  switch(error.status){
    case 403:
      props.showFlash(i18n.global.t('pages.common.messages.notEditAuthority'), "error", true)
      location.reload()
      break
    default:
      break
  }
}

function isDuplicationOffice() {
  let isDuplication = false

  requestIds.value.assigns.forEach((assignAccount) => {
    if (isDuplication) return
    if (assignAccount?.roles) {
      assignAccount.roles.forEach((role) => {
        if (
          selectedOrganizationAndRole.value.role &&
          selectedOrganizationAndRole.value.role.organization_type == role.organization_type &&
          selectedOrganizationAndRole.value.role.organization_id == role.organization_id &&
          role.id != selectedOrganizationAndRole.value.role.id
        ) return isDuplication = true
      })
    }
  })
  return isDuplication
}

function duplicateModalExec() {
  isConfirmed.value = true
  inforModalStatus.value = false
  createOrUpdate()
}

function changeDisplayAssigns(accounts: roleAssignAccountType[], isAssign: boolean) {
  if (isAssign) {
    displayAssigns.value = displayAssigns.value.concat(accounts)
    assigns.value = assigns.value.concat(accounts)
  } else {
    accounts.forEach((account) => {
      let index = displayAssigns.value.findIndex((displayAccount) => displayAccount.id === account.id)
      displayAssigns.value.splice(index, 1)
      assigns.value.splice(index, 1)
    })
  }
}

function handleResize() {
  windowInnerWidth.value = window.innerWidth;
}

function refreshAccounts() {
  displayAssigns.value = []
  selectableAccounts.value = []
  assigns.value = []
  requestIds.value.assigns = []
  requestIds.value.unassigns = []
}

watch(() => selectedOrganizationAndRole.value.role, (after, before) => {
  // 保存成功時に検索条件をリセットされないようにする
  if (!isSuccessed.value && after != before && alreadySelectedRoleId.value != after?.id) {
    refreshAccounts()
    searchItems.value = {
      organization: null,
      userName: ''
    }
  }
  isSuccessed.value = false
}, { deep: true })

window.addEventListener('resize', handleResize);

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(i18n).global.t('pages.roleAssignment.title')), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(RoleSelect, {
            modelValue: selectedOrganizationAndRole.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedOrganizationAndRole).value = $event)),
            organizations: organizations.value,
            roles: roles.value,
            windowInnerWidth: windowInnerWidth.value,
            errorMessages: filterValidationErrors.value
          }, null, 8, ["modelValue", "organizations", "roles", "windowInnerWidth", "errorMessages"]),
          _createVNode(UserSearch, {
            class: "mt-6",
            modelValue: searchItems.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchItems).value = $event)),
            selectedRole: selectedOrganizationAndRole.value.role,
            windowInnerWidth: windowInnerWidth.value,
            filter: filter,
            organizations: organizations.value,
            errorMessages: filterValidationErrors.value,
            loading: loading.value
          }, null, 8, ["modelValue", "selectedRole", "windowInnerWidth", "organizations", "errorMessages", "loading"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(PersonInCharge, {
            windowInnerWidth: windowInnerWidth.value,
            accounts: selectableAccounts.value,
            displayAssigns: displayAssigns.value,
            alreadyAssignedAccountIds: alreadyAssignedAccountIds.value,
            selectedRole: selectedOrganizationAndRole.value.role,
            organizations: organizations.value,
            changeDisplayAssigns: changeDisplayAssigns,
            modelValue: requestIds.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((requestIds).value = $event)),
            loading: loading.value
          }, null, 8, ["windowInnerWidth", "accounts", "displayAssigns", "alreadyAssignedAccountIds", "selectedRole", "organizations", "modelValue", "loading"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_v_btn, {
            class: "exec-btn",
            onClick: createOrUpdate,
            loading: isCreateOrUpdating.value,
            style: _normalizeStyle({
            backgroundColor : selectedOrganizationAndRole.value.role ? '' : '#B3B8BB'
          }),
            disabled: !selectedOrganizationAndRole.value.role
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(i18n).global.t('pages.common.button.conservation')), 1)
            ]),
            _: 1
          }, 8, ["loading", "style", "disabled"])
        ])
      ])
    ]),
    _createVNode(DuplicationConfirmModal, {
      modelValue: inforModalStatus.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((inforModalStatus).value = $event)),
      duplicateModalExec: duplicateModalExec
    }, null, 8, ["modelValue"])
  ], 64))
}
}

})